import {
  Autocomplete,
  Button,
  Checkbox,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Link, useParams, useNavigate } from "react-router-dom";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { generateNumber } from "../../utils/utils";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { fetchAddresses } from "../invoice/productDetails";
import moment from "moment";
import EditWrap from "../commonComponent/editWrap";
import { generateChallanPrint } from "./challanPrint";
import { ClassicTable } from "../../utils/components/Styles";
import { useTheme } from "@emotion/react";
import PreviewIcon from "@mui/icons-material/Preview";
import {
  FirstPage as FirstPageIcon,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage as LastPageIcon,
} from "@mui/icons-material";
import { getUsers } from "../../utils/databaseHelper";

const dispatchMediumList = [{ label: "Onsite" }, { label: "self-calibration" }];

const readingColumns = [
  [
    {
      field: "id",
      headerName: "Sr. No.",
      editable: false,
    },
    {
      field: "standards",
      headerName: "Master EQP",
      editable: true,
    },
    {
      field: "returnDate",
      headerName: "Return Date",
      editable: true,
    },
    {
      field: "action",
      headerName: "Action",
      editable: true,
    },
  ],
];

const checkPointArray = [
  {
    label: "Service Request Form",
    value: false,
    stateKey: "serviceRequestForm",
    section: "JD",
  },
  {
    label: "Observation Sheet",
    value: false,
    stateKey: "measurementSheet",
    section: "JD",
  },
  {
    label: "Calibration Procedure",
    value: false,
    stateKey: "calibrationProcedure",
    section: "JD",
  },
  {
    label: "Calibration Sticker",
    value: false,
    stateKey: "calibrationSticker",
    section: "JD",
  },
  { label: "Sticker Pen", value: false, stateKey: "stickerPen", section: "JD" },
  {
    label: "Master Instruments With Delivery Challan",
    value: false,
    stateKey: "masterInstruments",
    section: "JD",
  },

  {
    label: "Thermohygro Meter",
    value: false,
    stateKey: "thermohygroMeter",
    section: "TA",
  },
  {
    label: "Adjustable Spanner",
    value: false,
    stateKey: "adjustableSpanner",
    section: "TA",
  },
  {
    label: "Screw Driver Set",
    value: false,
    stateKey: "screwDriverSet",
    section: "TA",
  },
  {
    label: "Cutting Pliers",
    value: false,
    stateKey: "cuttingPliers",
    section: "TA",
  },
  { label: "Teflon Tape", value: false, stateKey: "teflonTape", section: "TA" },
  {
    label: "Insulation Tape",
    value: false,
    stateKey: "insulationTape",
    section: "TA",
  },
  {
    label: "Safety Shoe & Glouse",
    value: false,
    stateKey: "safetyShoeGlouse",
    section: "TA",
  },
  {
    label: "Tissue Paper Or Soft Cloth",
    value: false,
    stateKey: "tissuePaperCloth",
    section: "TA",
  },
  {
    label: "IPA and Cleanining Reagents",
    value: false,
    stateKey: "ipaCleaningReagents",
    section: "TA",
  },
  {
    label: "Powercord and Charger",
    value: false,
    stateKey: "powercordCharger",
    section: "TA",
  },
];

export default function EditChallan() {
  const params = useParams();
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState(null);
  const [clientsOption, setClientsOption] = useState([]);
  const [clientsObj, setClientsObj] = useState([]);
  const [allAddress, setAllAddress] = useState([]);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [standardArr, setStandardArr] = useState([]);
  const [allstandardList, setAllStandardArrList] = useState([]);
  const [readingRows, setReadingRows] = useState([]);
  const [selectedStdIDs, setselectedStdIDs] = useState([]);
  const [editAccess, setEditAccess] = useState(
    localStorage.getItem("editAccess")?.split(",").map(Number)
  );
  const [letterHead, setLetterHead] = useState(true);
  const [readingRowsID, setReadingRowsID] = useState([]);
  const [isCalibration, setIsCalibration] = useState(false);
  const [beforeCalibrationData, setBeforeCalibrationData] = useState([]);
  const [afterCalibrationData, setAfterCalibrationData] = useState([]);
  const [srfList, setSrfList] = useState([]);

  const [challanDetails, setChallanDetails] = useState({
    dispatchMedium: "",
    outwardDate: "",
    expectedReturnDate: "",
    additionalAccessories: "",
    outChallanNo: "",
    standardtIds: [],
    purpose: "",
    srfNo: "",
  });

  const transformData = (data) => {
    return data.reduce((acc, item) => {
      const { section, stateKey, value } = item;
      if (!acc[section]) {
        acc[section] = {};
      }
      acc[section][stateKey] = value;
      return acc;
    }, {});
  };

  const [checkPointData, setCheckPointData] = useState(checkPointArray);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div style={{ flexShrink: 0, marginLeft: "2.5em" }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          <FirstPageIcon />
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          <LastPageIcon />
        </IconButton>
      </div>
    );
  }

  const handleCellChange = (newValue, id, field) => {
    const formattedValue =
      field.toLowerCase().includes("date") && newValue
        ? moment(newValue).format("YYYY-MM-DD")
        : newValue;

    setReadingRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, [field]: formattedValue } : row
      )
    );
  };

  const refresh = () => window.location.reload(false);

  const updateSrfObject = (key, value) => {
    setChallanDetails((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const getStandardList = (outwardDate) => {
    let url = BASE_URL;
    const formattedDate = moment(outwardDate).format("YYYY-MM-DD");
    if (params.challanNo == 0) {
      const query = {
        query: `SELECT s.* FROM standards s WHERE s.id = (SELECT s2.id FROM standards s2 WHERE s2.stId = s.stId and s2.status = 1 AND DATE(s2.calDate) <= '${formattedDate}' ORDER BY s2.calDate DESC LIMIT 1) AND s.status = 1 AND DATE(s.validUpto) >= '${formattedDate}' AND s.id NOT IN (SELECT standardtIds FROM standardInOutChallan WHERE standardtIds IS NOT NULL AND outwardDate IS NOT NULL AND (returnDate IS NULL OR returnDate >= NOW()) AND status = 1);`
      };

      axiosWithToken
        .post(url + `dynamic`, query)
        .then((res) => {
          const standardList = [];
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].standardName != null)
              standardList.push({
                id: res.data[i].id,
                label: res.data[i].standardName,
                stId: res.data[i].stId,
                make: res.data[i].make,
                model: res.data[i].model,
                calDate: res.data[i].calDate,
                validUpto: res.data[i].validUpto,
              });
          }
          setStandardArr(standardList);
        })
        .catch((error) => {
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
        });
    } else {
      axiosWithToken
        .get(url + "standards?_where=(status,eq,1)")
        .then((res) => {
          const standardList = [];
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].standardName != null)
              standardList.push({
                id: res.data[i].id,
                label: res.data[i].standardName,
                stId: res.data[i].stId,
                make: res.data[i].make,
                model: res.data[i].model,
                calDate: res.data[i].calDate,
                validUpto: res.data[i].validUpto,
              });
          }
          setStandardArr(standardList);
        })
        .catch((error) => {
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
        });
    }
  };

  const getAllStandard = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + "standards?_where=(status,eq,1)")
      .then((res) => {
        setAllStandardArrList(res.data);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const getSrfListByClientId = () => {
    let url = BASE_URL;
    let query = {
      query: `select * from srfs where clientId = ${companyName}`
    }
    axiosWithToken
      .post(url + `dynamic`, query)
      .then((res) => setSrfList(res.data))
      .catch((error) => console.log(error));
  };

  const getClientList = () => {
    axiosWithToken
      .get(`${BASE_URL}clients?_where=(status,eq,1)`)
      .then((res) => {
        const clients = res.data.map((c) => ({
          label: `${c.id}, ${c.companyName}`,
        }));
        const tClientsObj = {};
        res.data.forEach((c) => (tClientsObj[c.id] = c));
        setClientsOption(res.data);
        setClientsObj(tClientsObj);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const debouncedFetchAddresses = async (addressIds, shippingAddressIds) => {
    setLoading(true);
    const newAddressArray = await fetchAddresses(
      addressIds,
      shippingAddressIds
    );
    setAllAddress(newAddressArray);
    setLoading(false);
  };

  const getChallanList = () => {
    const query = {
      query: `SELECT c.companyName, si.address,si.id, si.returnDate, si.standardtIds, si.srfNo, si.outChallanNo, si.additionalAccessories,si.dispatchMedium,si.purpose, si.outwardDate, si.expectedReturnDate, si.clientId,si.toolsDetails, si.jobDetails FROM standardInOutChallan si JOIN clients c ON si.clientId = c.id WHERE si.status = 1 and si.outChallanNo = '${params.challanNo}'`,
    };
    axiosWithToken
      .post(`${BASE_URL}dynamic`, query)
      .then((res) => {
        setReadingRows(res.data);
        setReadingRowsID(res.data.map((item) => item.id));

        const allStandardtIds = res.data
          ?.map((item) => item.standardtIds)
          .filter(Boolean) // remove null/undefined
          .flatMap((ids) =>
            ids.split(",").map((id) => parseInt(id.trim(), 10))
          );

        const data = res.data[0];
        setCompanyName(data.companyName);
        debouncedFetchAddresses(data.address, "");
        setChallanDetails({
          id: data.id,
          dispatchMedium: data.dispatchMedium,
          purpose: data.purpose || "",
          outChallanNo: data.outChallanNo,
          srfNo: data.srfNo,
          additionalAccessories: data.additionalAccessories,
          outwardDate: moment(data.outwardDate).format("YYYY-MM-DD") || "",
          expectedReturnDate:
            moment(data.expectedReturnDate).format("YYYY-MM-DD") || "",
          standardtIds: allStandardtIds || [],
        });

        const toolsData = data.toolsDetails
          ? JSON.parse(data.toolsDetails)
          : {};
        const documentData = data.jobDetails ? JSON.parse(data.jobDetails) : {};
        const updatedData = checkPointData.map((item) => ({
          ...item,
          value:
            toolsData[item.stateKey] ??
            documentData[item.stateKey] ??
            item.value,
        }));

        setCheckPointData(updatedData);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const handleSubmit = () => {
    const url = BASE_URL;

    const standardIds = challanDetails?.standardtIds;
    const checkPointKeyAndValue = transformData(checkPointData);

    const payloads = standardIds?.map((standardIds) => {
      const matchingRow = readingRows?.find(
        (row) => row.standardtIds == standardIds
      );

      return {
        ...(params.challanNo == 0 && {
          clientId: companyName || null,
          address: address || null,
        }),
        ...(params.challanNo != 0 && {
          id: matchingRow?.id || null,
          returnDate: matchingRow?.returnDate
            ? moment(matchingRow.returnDate).format("YYYY-MM-DD")
            : null,
        }),
        dispatchMedium: challanDetails.dispatchMedium,
        purpose: challanDetails.purpose || null,
        outChallanNo: challanDetails.outChallanNo || null,
        srfNo: challanDetails.srfNo || null,
        outwardDate: challanDetails.outwardDate
          ? moment(challanDetails.outwardDate).format("YYYY-MM-DD")
          : null,
        expectedReturnDate: challanDetails.expectedReturnDate
          ? moment(challanDetails.expectedReturnDate).format("YYYY-MM-DD")
          : null,
        additionalAccessories: challanDetails.additionalAccessories || null,
        standardtIds: standardIds,
        jobDetails: JSON.stringify(checkPointKeyAndValue?.JD || {}),
        toolsDetails: JSON.stringify(checkPointKeyAndValue?.TA || {}),
      };
    });

    if (params.challanNo == 0) {
      if (!companyName) return toast.error("Select Client!");
      if (!challanDetails.outChallanNo) return toast.error("Enter Challan No.");
      if (!challanDetails.standardtIds.length)
        return toast.error("Select Standards!");
      if (!challanDetails.outwardDate)
        return toast.error("Select Outward Date!");

      axiosWithToken
        .post(url + "standardInOutChallan/bulk", payloads)
        .then((res) => {
          toast.success("standards In/Out Challan created successfully !");
          setTimeout(refresh, 500);
        })
        .catch((error) => {
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
        });
    } else {
      axiosWithToken
        .patch(url + "bulk/standardInOutChallan", payloads)
        .then((res) => {
          toast.success("standards In/Out Challan Updated successfully !");
          setTimeout(refresh, 500);
        })
        .catch((error) => {
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
        });
    }
  };
  // function for delete
  const handleDeleteClick = async (rowId) => {
    if (!window.confirm("Are you sure you want to delete this Master?")) return;
    try {
      await axiosWithToken.delete(BASE_URL + `standardInOutChallan/${rowId}`);

      await axiosWithToken.post(BASE_URL + "dynamic", {
        query: `DELETE FROM stdInOutReadings WHERE challanInOutId='${rowId}'`,
      });
      toast.success("Master Deleted successfully!");
      navigate("/challanList");
    } catch (e) {
      console.error(e);
    }
  };

  const [settingsList, setSettgingList] = useState([]);
  const fetchSettings = () => {
    axiosWithToken
      .post(BASE_URL + 'dynamic', {
        query: `SELECT * FROM settings where status = 1`
      })
      .then((res) => {
        setSettgingList(res.data);
      })
      .catch((error) => console.log(error));
  };

  const getNextChallanNumber = async () => {
    const res = await axiosWithToken.post(BASE_URL + "dynamic", {
      query: `SELECT outChallanNo FROM standardInOutChallan where status = 1 ORDER BY id DESC LIMIT 1`
    });
    const last = res.data[0]?.outChallanNo;
    if (!last) return 1;
    const num = +last.split("/").pop() + 1;
    return num;
  };

  const generateChallan = async () => {
    const challanSetting = settingsList.find((s) => s.keyName === "ChallanGetPass");
    const nextUid = await getNextChallanNumber();
    const generated = generateNumber(
      challanSetting?.value || "BFI/YYYY/{no}",
      nextUid,
      {
        entryDate: challanDetails.outwardDate || new Date(),
      }
    );
    updateSrfObject("outChallanNo", generated);
  };

  useEffect(() => {
    if (params.challanNo == 0 && settingsList.length > 0) {
      generateChallan();
    }
  }, [settingsList, challanDetails.outwardDate]);

  useEffect(() => {
    getClientList();
    getStandardList();
    getAllStandard();
    fetchSettings();
    if (params.challanNo != 0) getChallanList();
  }, []);

  useEffect(() => {
    if (params.challanNo == 0) {
      getSrfListByClientId();
    }
  }, [companyName]);

  useEffect(() => {
    if (
      params.challanNo == 0 ||
      !challanDetails?.standardtIds?.length ||
      !allstandardList?.length
    )
      return;

    const selectedStdData = allstandardList.filter((std) =>
      challanDetails.standardtIds.includes(std.id)
    );
    setselectedStdIDs(selectedStdData);
  }, [params.challanNo, challanDetails?.standardtIds, allstandardList]);

  const getStdInOutReadings = (challanInOutId) => {
    let url = BASE_URL;
    let payload = {
      query: `SELECT * FROM stdInOutReadings WHERE challanInOutId IN (${challanInOutId.join(",")})`,
    };
    axiosWithToken
      .post(`${url}dynamic`, payload)
      .then((res) => {
        const beforeCalibrationData = res.data
          ?.filter((item) => item.type === 1)
          ?.map(({ type, ...rest }) => rest);

        const afterCalibrationData = res.data
          ?.filter((item) => item.type === 2)
          ?.map(({ type, ...rest }) => rest);

        setBeforeCalibrationData(beforeCalibrationData);
        setAfterCalibrationData(afterCalibrationData);
      })
      .catch((error) => console.log(error));
  };

  // const getChallanData = (id) => {
  //   let url = BASE_URL;
  //   let payload = {
  //     query: `SELECT sIOC.*, s.stId, s.standardName FROM standardInOutChallan sIOC LEFT JOIN standards s ON sIOC.standardtIds = s.id WHERE sIOC.id in (${id.join(",")})`,
  //   };
  //   axiosWithToken
  //     .post(`${url}dynamic`, payload)
  //     .then((res) => setChallanDetails(res.data?.[0]))
  //     .catch((error) => console.log(error));
  // };

  useEffect(() => {
    if (readingRowsID?.length > 0) {
      getStdInOutReadings(readingRowsID);
      // getChallanData(readingRowsID);
    }
  }, [readingRowsID]);

  const handleChange = (index) => {
    const newData = [...checkPointData];
    newData[index].value = !newData[index].value;
    setCheckPointData(newData);
  };

  let generetepdfProps = {
    companyName,
    allAddress,
    challanDetails,
    letterHead,
    selectedStdIDs,
    isCalibration,
    beforeCalibrationData,
    afterCalibrationData,
    instrumentData: readingRows
      ?.filter((ele) => readingRowsID?.map(Number)?.includes(ele.id))
      ?.map((item) => {
        const stdId = Number(item.standardtIds);
        const matchedStandard = standardArr.find((std) => std.id === stdId);

        return {
          ...item,
          label: matchedStandard?.label || null,
          stId: matchedStandard?.stId || null,
          make: matchedStandard?.make || null,
          model: matchedStandard?.model || null,
          calDate: matchedStandard?.calDate || null,
          validUpto: matchedStandard?.validUpto || null,
        };
      }),
    checkPointData,
  };

  return (
    <EditWrap>
      <Typography variant="h6" component="h6" textAlign={"left"}>
        {params?.challanNo != 0 ? "Edit" : "Create"} Challan
      </Typography>
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          {params.challanNo != 0 ? (
            <TextField
              label="Client *"
              size="small"
              disabled
              value={companyName || ""}
              fullWidth
              variant="outlined"
            />
          ) : (
            <Autocomplete
              size="small"
              options={clientsOption}
              getOptionLabel={(option) =>
                `${option.id}, ${option.companyName +
                (option.uniCode ? ` (${option.uniCode})` : "")
                }`
              }
              renderInput={(params) => <TextField {...params} label="Client *" />}
              onChange={(event, value) => {
                if (value) {
                  debouncedFetchAddresses(
                    value?.address,
                    value?.shippingAddress
                  );
                  setCompanyName(parseInt(value.id));
                  setAddress(clientsObj[parseInt(value.id)].address);
                } else {
                  setCompanyName(null);
                  setAddress("");
                }
              }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          {allAddress?.length === 1 ? (
            <TextField
              value={allAddress[0]?.address}
              label="Address *"
              fullWidth
              variant="outlined"
              size="small"
              disabled
            />
          ) : (
            <Autocomplete
              disabled={params.challanNo != 0}
              options={allAddress}
              size="small"
              getOptionLabel={(option) => option?.address}
              renderInput={(params) => (
                <TextField {...params} label="Address *" variant="outlined" />
              )}
              onChange={(event, value) => {
                setAddress(value?.id);
              }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="Outward Date *"
              format="dd/MM/yyyy"
              value={
                challanDetails.outwardDate
                  ? new Date(challanDetails.outwardDate)
                  : null
              }
              onChange={(newValue) => {
                updateSrfObject("outwardDate", newValue);
                if (params.challanNo == 0 && newValue) {
                  getStandardList(moment(newValue).format("YYYY-MM-DD"));
                }
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            multiple
            disabled={params.challanNo != 0}
            id="outlined-basic"
            size="small"
            options={standardArr}
            value={standardArr.filter((opt) =>
              challanDetails.standardtIds.includes(opt.id)
            )}
            disableCloseOnSelect
            getOptionLabel={(option) =>
              `${option.stId} : ${option.label}` || ""
            }
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.stId}: {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Master EQP *"
                placeholder="Select multiple Standards"
              />
            )}
            onChange={(event, value) => {
              updateSrfObject(
                "standardtIds",
                value.map((opt) => opt.id)
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            label="Challan No *"
            value={challanDetails.outChallanNo}
            size="small"
            fullWidth
            variant="outlined"
            onChange={(e) => updateSrfObject("outChallanNo", e.target.value)}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          {params.challanNo == 0 ?
            <Autocomplete
              multiple
              id="srf-autocomplete"
              fullWidth
              size="small"
              options={srfList}
              getOptionLabel={(option) => option.serviceReqNumber}
              value={
                // Convert stored comma-separated string to array of objects
                challanDetails?.srfNo
                  ? challanDetails.srfNo.split(",").map((srf) =>
                    srfList.find((item) => item.serviceReqNumber === srf)
                  ).filter(Boolean) // remove any undefined if mismatch
                  : []
              }
              onChange={(event, newValue) => {
                const srfNumbers = newValue.map((item) => item.serviceReqNumber).join(",");
                updateSrfObject("srfNo", srfNumbers);
              }}
              renderInput={(params) => (
                <TextField {...params} label="SRF Number" variant="outlined" />
              )}
            /> :
            <TextField
              id="outlined-basic"
              label="SRF Number"
              fullWidth
              size="small"
              value={challanDetails?.srfNo}
              multiline
              variant="outlined"
              onChange={(e) => {
                updateSrfObject("srfNo", e.target.value);
              }}
              disabled
            />
          }
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            label="Dispatch Medium"
            value={challanDetails.dispatchMedium}
            size="small"
            fullWidth
            variant="outlined"
            onChange={(e) => updateSrfObject("dispatchMedium", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            size="small"
            options={dispatchMediumList}
            value={challanDetails.purpose}
            renderInput={(params) => <TextField {...params} label="Purpose" />}
            onChange={(event, value) => {
              updateSrfObject("purpose", value?.label || "");
            }}
            disabled={params.challanNo != 0}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="Expected Return Date *"
              format="dd/MM/yyyy"
              value={
                challanDetails.expectedReturnDate
                  ? new Date(challanDetails.expectedReturnDate)
                  : null
              }
              onChange={(newValue) => {
                updateSrfObject("expectedReturnDate", newValue);
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            label="Additional Accessories"
            value={challanDetails.additionalAccessories}
            size="small"
            fullWidth
            multiline
            minRows={3}
            maxRows={5}
            variant="outlined"
            onChange={(e) =>
              updateSrfObject("additionalAccessories", e.target.value)
            }
          />
        </Grid>
      </Grid>
      <hr />
      <Typography
        variant="h6"
        component="h6"
        textAlign={"center"}
        style={{ fontSize: "18px" }}
      >
        CHECK LIST FOR ONSITE CALIBRATION
      </Typography>
      <br />
      <Grid container spacing={2}>
        {/* Job Detail Section */}
        <Grid item xs={12}>
          <h6
            style={{
              fontSize: "18px",
              textAlign: "left",
              fontWeight: "bold",
              marginTop: "15px",
            }}
          >
            Job Details
          </h6>
          <Grid container spacing={2}>
            {checkPointData
              .filter((item) => item.section === "JD")
              .map((item, index) => (
                <Grid item xs={4} key={item.stateKey}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      checked={item.value}
                      onChange={() =>
                        handleChange(checkPointData.indexOf(item))
                      }
                    />
                    <span>{item.label}</span>
                  </div>
                </Grid>
              ))}
          </Grid>
        </Grid>
        {/* Tools/Accessories Section */}
        <Grid item xs={12}>
          <h6
            style={{
              fontSize: "18px",
              textAlign: "left",
              fontWeight: "bold",
              marginTop: "15px",
            }}
          >
            Tools/Accessories
          </h6>
          <Grid container spacing={2}>
            {checkPointData
              .filter((item) => item.section === "TA")
              .map((item, index) => (
                <Grid item xs={4} key={item.stateKey}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      checked={item.value}
                      onChange={() =>
                        handleChange(checkPointData.indexOf(item))
                      }
                    />
                    <span>{item.label}</span>
                  </div>
                </Grid>
              ))}
          </Grid>
        </Grid>
      </Grid>

      <br />
      <hr />
      {params.challanNo != 0 && (
        <>
          <h4 style={{ marginBottom: "15px" }}>Master Records</h4>
          <div style={{ width: "100%", overflow: "hidden" }}>
            <ClassicTable>
              <TableContainer sx={{ maxHeight: "85vh" }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  size="small"
                  className="table-responsive"
                  id="certificate-certificatelisttable"
                  sx={{ borderCollapse: "collapse" }}
                >
                  <TableHead>
                    <TableRow>
                      {readingColumns[0].map((column) => (
                        <TableCell key={column.field}>
                          {" "}
                          <Typography noWrap sx={{ fontSize: "14px" }}>
                            {column.headerName}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {readingRows
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row, index) => {
                        const standard = standardArr?.find(
                          (el) => el.id == row.standardtIds
                        );
                        const userIds = row.userId
                          ?.split(",")
                          ?.map((id) => parseInt(id.trim(), 10)); // Split userId string and convert each ID to an integer

                        return (
                          <TableRow key={index}>
                            <TableCell sx={{ fontSize: "12px" }}>
                              {page * rowsPerPage + index + 1}
                            </TableCell>
                            <TableCell sx={{ fontSize: "12px" }}>
                              {standard
                                ? `${standard.stId}: ${standard.label}`
                                : ""}
                            </TableCell>

                            <TableCell>
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <DatePicker
                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      fullWidth: true,
                                    },
                                  }}
                                  inputFormat="dd/MM/yyyy"
                                  format="dd/MM/yyyy"
                                  value={
                                    row.returnDate
                                      ? new Date(row.returnDate)
                                      : ""
                                  }
                                  onChange={(newValue) => {
                                    handleCellChange(
                                      newValue,
                                      row.id,
                                      "returnDate"
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      size="small"
                                      fullWidth
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            </TableCell>

                            <TableCell sx={{ fontSize: "12px" }}>
                              <Tooltip
                                title="Edit StandardInOut"
                                placement="top-start"
                              >
                                <Button
                                  component={Link}
                                  to={`/challanCalibration/${row.id}`}
                                >
                                  <PreviewIcon />
                                </Button>
                              </Tooltip>
                              <Tooltip
                                title="Delete StandardInOut"
                                placement="top-start"
                              >
                                <Button
                                  style={{ cursor: "pointer", color: !(editAccess?.includes(2) || editAccess?.includes(0)) ? 'lightgray' : '#dc3545' }}
                                  onClick={() => {
                                    if (!(editAccess?.includes(2) || editAccess?.includes(0))) {
                                      return;
                                    }
                                    handleDeleteClick(row.id)
                                  }}
                                  color="error"
                                  size="small"
                                >
                                  <DeleteIcon />
                                </Button>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={readingRows.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 30, 50]}
                ActionsComponent={TablePaginationActions}
              />
            </ClassicTable>
          </div>
        </>
      )}

      <br />
      <Toolbar
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
          marginTop: "3rem",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "20px",
          }}
        >
          {params.challanNo != 0 && (
            <>
              <Autocomplete
                size="small"
                sx={{ minWidth: "200px" }}
                options={[
                  { id: 1, label: "With Calibration" },
                  { id: 2, label: "Without Calibration" },
                ]}
                renderInput={(params) => (
                  <TextField {...params} label="Calibration" />
                )}
                onInputChange={(event, newInputValue) => {
                  if (
                    newInputValue === "With Calibration" ||
                    newInputValue === ""
                  ) {
                    setIsCalibration(true);
                  } else if (newInputValue === "Without Calibration") {
                    setIsCalibration(false);
                  }
                }}
              />
              <Autocomplete
                size="small"
                sx={{ minWidth: "200px" }}
                options={[
                  { id: 1, label: "With Letter Head" },
                  { id: 2, label: "Without Letter Head" },
                ]}
                renderInput={(params) => (
                  <TextField {...params} label="letterHead" />
                )}
                onInputChange={(event, newInputValue) => {
                  if (
                    newInputValue === "With Letter Head" ||
                    newInputValue === ""
                  ) {
                    setLetterHead(true);
                  } else if (newInputValue === "Without Letter Head") {
                    setLetterHead(false);
                  }
                }}
              />
              <Button
                variant="contained"
                size="small"
                onClick={() => generateChallanPrint(generetepdfProps)}
              >
                Print
              </Button>
            </>
          )}
        </div>
        <div
          style={{
            display: "flex",
            gap: "20px",
          }}
        >
          <Button
            variant="contained"
            style={{ backgroundColor: "grey" }}
            size="small"
            onClick={() => {
              if (window.confirm("Are you sure you want to cancel?")) {
                window.history.back();
              }
            }}
          >
            Cancel
          </Button>
          <Tooltip
            title={
              !(editAccess?.includes(1) || editAccess?.includes(0))
                ? "You don't have access"
                : ""
            }
          >
            <Button
              variant="contained"
              size="small"
              disabled={!(editAccess?.includes(1) || editAccess?.includes(0))}
              onClick={handleSubmit}
            >
              {` ${params.challanNo != 0 ? "Update" : "Save"}`}
            </Button>
          </Tooltip>
        </div>
      </Toolbar>
    </EditWrap>
  );
}
